<template>
    <div class="animated fadeIn">
        <div>
            <b-row>
                <b-col sm="12">
                    <div>
                        <b-table
                            class="tableRadius professional-stacked-table"
                            :items="bulkReportList"
                            :fields="uploadColumns"
                            :dark="false"
                            :hover="true"
                            thead-class="header"
                            :striped="false"
                            :bordered="true"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :small="false"
                            show-empty
                            :fixed="false"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            responsive
                            stacked="md"
                        >
                            <template slot="cell(createdAt)" slot-scope="data">
                                <div>
                                    {{ data.item.createdAt | formatedate }}
                                </div>
                            </template>
                            <template slot="cell(download)" slot-scope="data">
                                <b-button
                                    variant="primary"
                                    @click="download(data.item.inputSheet)"
                                    >Download
                                </b-button>
                            </template>
                        </b-table>
                        <b-row class="mx-0 justify-content-end p-3">
                            <b-pagination
                                v-model="currentPage"
                                :per-page="perPage"
                                :total-rows="filterCount"
                                aria-controls="my-table"
                                prev-text="Prev"
                                next-text="Next"
                                hide-goto-end-buttons
                            ></b-pagination>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    name: "Upload-History",
    data() {
        return {
            filterCount: 0,
            loading: false,
            currentPage: 1,
            filter: "",
            sortBy: "createdAt",
            sortDesc: true,
            perPage: 9,
            uploadColumns: [
                {
                    key: "_id",
                    label: "Request ID",
                },
                {
                    key: "jobType",
                    label: "Type",
                },
                {
                    key: "stats.totalProcessed",
                    label: "Total Items",
                },
                {
                    key: "stats.success",
                    label: "Successful",
                },
                {
                    key: "stats.failed",
                    label: "Failed",
                },
                {
                    key: "createdAt",
                    label: "Time",
                },
                {
                    key: "download",
                    label: "Download",
                },
            ],
        };
    },
    computed: {
        bulkReportList() {
            let dataList = this.$store.getters["partner/GetBulkCustomerList"];
            return dataList;
        },
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm A");
            }
        },
    },
    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        getBulkList() {
            this.loading = true;
            this.$store
                .dispatch("partner/getBulkCustomerList")
                .then((data) => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        download(URL) {
            window.open(URL, "_blank");
        },
    },
    async mounted() {
        this.getBulkList();
        const uploadList =
            this.$store.getters["partner/GetPartnerCustomerList"];
        if (!uploadList || !uploadList.length) {
            this.getBulkList();
        }
    },
};
</script>
